import RepositoryFactory from '@/repository/RepositoryFactory';
const managerServiceRepositories = RepositoryFactory.manager;

angular.module('inspinia').factory('agenciesService', function (serverService, $http) {
  let state = {
    agencies: [],
  };

  // Getters

  /**
   * 再販代理店一覧取得
   * @returns 再販代理店一覧
   */
  const getResaleAgencies = () => {
    return state.agencies.filter((agency) => agency.name === '再販代理店');
  };

  /**
   * コドモンが債権者になっている施設を返す。
   */
  const getDirectContractFacilities = () => {
    return state.agencies.filter((agency) => {
      return (
        agency.name === '直販' ||
        agency.name === '自治体エリアパートナー' ||
        agency.name === '取次代理店' ||
        agency.name === '取次代理店+'
      );
    });
  };

  const containsDirectContractFacilities = (manageFacilityId) => {
    if (!manageFacilityId) return false;
    return getDirectContractFacilities().some((facility) => facility.id === manageFacilityId);
  };

  // Mutations

  /**
   * @param {*} fetchedAgencies APIで取得した代理店情報
   */
  const setAgencies = (agencies) => {
    state.agencies = agencies;
  };

  const getAgencies = () => {
    return state.agencies;
  };

  // Actions

  /**
   * 初期化処理
   */
  const initialize = async () => {
    const params = {};

    // 代理店一覧取得
    const response = await managerServiceRepositories.agencies.index(params);

    if (response.data.data.length === 0) return;
    setAgencies(response.data.data);
  };

  return {
    ...state,
    getResaleAgencies,
    getDirectContractFacilities,
    containsDirectContractFacilities,
    setAgencies,
    getAgencies,
    initialize,
  };
});
